
<template>
  <div v-bind:id="'question' + getId()" class="question" v-bind:class="element.animation">
    <div class="speech-bubble">
      {{element.text}}
    </div>
    <div v-show="element.extra != null && typeof(element.extra) != 'undefined'" class="speech-bubble-left mt-3" v-bind:class="element.extraanimation">
      {{element.extra}}
    </div>
  </div>
</template>

<script>
  export default {
    name: 'onboarding-question',
    components: {
    },
    props: {
      element: {
        required: false,
        type: Object,
        default() {
          return { extra: null, animation:""}
        }
      },
      step: {
        required: false,
        type: Object,
        default() {
          return null
        }
      },
    },
    data() {
      return {
      }
    },
    methods: {
      getId() {
        return this._uid;
      },
      hide() {
        $('#question' + this.getId()).hide();
      },
      show() {
        $('#question' + this.getId()).show();
      },
    },
    created() {

    },
    mounted() {

    }
  }
</script>

<style scoped>

  .speech-bubble-left {
    position: relative;
    background: #0091bb;
    border-radius: .4em;
    padding-top: 40px;
    padding-left: 60px;
    padding-right: 60px;
    padding-bottom: 40px;
    font-size: 24px;
    color: white;
    float: left;
    left: 30px;
    max-width: 60%;
  }

    .speech-bubble-left:after {
      content: '';
      position: absolute;
      left: 1px;
      top: 50%;
      width: 0;
      height: 0;
      border: 45px solid transparent;
      border-right-color: #0091bb;
      border-left: 0;
      border-bottom: 0;
      margin-top: -22.5px;
      margin-left: -45px;
    }

  .speech-bubble {
    position: relative;
    background: #0091bb;
    border-radius: .4em;
    padding-top: 20px;
    padding-left: 40px;
    padding-right: 40px;
    padding-bottom: 20px;
    font-size: 24px;
    color: white;
    float: right;
    right: 30px;
    max-width:60%;
  }

    .speech-bubble:after {
      content: '';
      position: absolute;
      right: 0;
      top: 50%;
      width: 0;
      height: 0;
      border: 45px solid transparent;
      border-left-color: #0091bb;
      border-right: 0;
      border-bottom: 0;
      margin-top: -22.5px;
      margin-right: -45px;
    }

  @media (max-width: 768px) {
    .speech-bubble-left {
      font-size: 18px;
    }
    .speech-bubble {
      font-size: 18px;
    }
  }

  .delay-1 {
    animation-delay: 1s;
  }

  .delay-2 {
    animation-delay: 2s;
  }

  .delay-3 {
    animation-delay: 3s;
  }

  .delay-4 {
    animation-delay: 4s;
  }


  .duration-1 {
    animation-duration: 1s;
  }

  .duration-2 {
    animation-duration: 2s;
  }

  .duration-3 {
    animation-duration: 3s;
  }

  .duration-4 {
    animation-duration: 4s;
  }

  .duration-5 {
    animation-duration: 5s;
  }

  .duration-6 {
    animation-duration: 6s;
  }

  .duration-7 {
    animation-duration: 7s;
  }

  .duration-8 {
    animation-duration: 8s;
  }

  .duration-9 {
    animation-duration: 9s;
  }

  .duration-10 {
    animation-duration: 10s;
  }

  .duration-15 {
    animation-duration: 15s;
  }

</style>



// WEBPACK FOOTER //
// src/components/onboarding/onboarding-question.vue